import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import heroImg from '../images/main.svg';

const Hero = () => {
    return (
        <>
            <div className="hero" id="hero">
                <NavBar />
                
                <div className="container mx-auto px-6 max-w-7xl relative z-10 py-10 md:py-16" data-aos="zoom-in">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
                        
                        {/* Text Content */}
                        <div className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left" data-aos="zoom-in" data-aos-delay="200">
                            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-3 text-slate-900">
                                YANIVA
                            </h1>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold italic mb-6 text-cyan-600">
                                Prosper Together
                            </h2>
                            <p className="text-lg md:text-xl leading-relaxed text-slate-600 mb-8 max-w-xl mx-auto lg:mx-0">
                                Partner in growth and value creation through SME and Mainboard IPOs. Aspiring to transform your company into successfully listed entities.
                            </p>
                            
                            {/* CTA Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                                <Link 
                                    to="/sme" 
                                    className="px-8 py-3.5 text-center text-white font-semibold bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl shadow-lg shadow-cyan-500/20 hover:shadow-cyan-500/35 hover:-translate-y-0.5 transition-all duration-300"
                                >
                                    SME IPO Solutions
                                </Link>
                                <Link 
                                    to="/contact" 
                                    className="px-8 py-3.5 text-center text-slate-700 font-semibold bg-white hover:bg-slate-50 border border-slate-200 rounded-xl shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300"
                                >
                                    Contact Us
                                </Link>
                            </div>
                        </div>

                        {/* Image Content */}
                        <div className="w-full lg:w-1/2 flex justify-center lg:justify-end" data-aos="fade-up" data-aos-delay="500">
                            <div className="relative w-full max-w-lg lg:max-w-none">
                                <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/10 to-indigo-500/10 rounded-3xl filter blur-3xl -z-10"></div>
                                <img 
                                    alt="Yaniva Banner Graphic" 
                                    className="w-full h-auto object-contain rounded-2xl hover:scale-[1.02] transition-transform duration-700 ease-in-out" 
                                    src={heroImg} 
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Hero;